import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { DEFAULT_CONTENT } from "../mock";

const SiteContext = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Deep-merge that lets the API override individual top-level keys
// but falls back to defaults when a key is missing entirely.
function mergeSite(defaults, override) {
  if (!override || typeof override !== "object") return defaults;
  const out = { ...defaults };
  for (const k of Object.keys(override)) {
    if (override[k] !== undefined && override[k] !== null) {
      out[k] = override[k];
    }
  }
  return out;
}

export const SiteProvider = ({ children }) => {
  const [site, setSite] = useState(DEFAULT_CONTENT);
  const [ready, setReady] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/content`);
      if (data && data.data) {
        setSite(mergeSite(DEFAULT_CONTENT, data.data));
      } else {
        setSite(DEFAULT_CONTENT);
      }
    } catch {
      setSite(DEFAULT_CONTENT);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <SiteContext.Provider value={{ site, ready, refresh, defaults: DEFAULT_CONTENT }}>
      {children}
    </SiteContext.Provider>
  );
};

export const useSite = () => {
  const ctx = useContext(SiteContext);
  if (!ctx) throw new Error("useSite must be used inside <SiteProvider>");
  return ctx.site;
};

export const useSiteMeta = () => {
  const ctx = useContext(SiteContext);
  if (!ctx) throw new Error("useSiteMeta must be used inside <SiteProvider>");
  return ctx;
};
